import React, {createContext, useState, useEffect} from 'react'

const LinkContext = createContext();


function Contextprovider({children}) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {

        fetch('site.json')
        .then(response => response.json())
        .then(data => {
            setData(data);
            setLoading(false);
            const doc = document.documentElement;
            if(data.gradientcolors !== ["",""]) { 
            doc.style.setProperty('--gradient1', data.gradientcolors[0]);
            doc.style.setProperty('--gradient2', data.gradientcolors[1]);}

            if(data.cardcolor !== "") {
                doc.style.setProperty('--cardcolor', data.cardcolor);
            doc.style.setProperty('--cardcolorlow', data.cardcolor + "90");}

            if(data.cardtextcolor !== "") {
            doc.style.setProperty('--textcolor', data.cardtextcolor);}

        })
    
    }, [])




    
 

  return (
    <LinkContext.Provider value={{data, loading}}>
        {children}
    </LinkContext.Provider>

  )
}

export default Contextprovider 
export {LinkContext};